import { gatewayPhone } from "src/gateways/gatewayPhone";

export interface ResolveBulkContactsPayload {
    companyId: number | string;
    phones: string[];
}

export interface ResolvedContact {
    uid: string;
    companyId: number;
    phoneNumber: string;
    name?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    businessName?: string | null;
    type?: string | null;
    role?: string | null;
    email?: string | null;
    notes?: string | null;
    source?: "contact" | string;
    createdAt?: string;
    updatedAt?: string;
}

export type ResolveBulkContactsResponse = Record<string, ResolvedContact>;

export const resolveBulkContacts = async ({
    companyId,
    phones,
}: ResolveBulkContactsPayload): Promise<ResolveBulkContactsResponse> => {
    const cleanPhones = Array.from(
        new Set(
            phones
                .map((phone) => phone?.trim())
                .filter(Boolean),
        ),
    );

    if (!companyId || cleanPhones.length === 0) {
        return {};
    }

    const response = await gatewayPhone.post<ResolveBulkContactsResponse>(
        "/contacts/resolve-bulk",
        {
            companyId: Number(companyId),
            phones: cleanPhones,
        },
    );

    return response.data;
};